import type { NextPage, GetStaticProps } from 'next';

import PageService from 'services/PageService/PageService';
import DownloadApp from 'blocks/DownloadApp/DownloadApp';
import { IGenericPage } from 'types/interfaces';
import GlobalLayout from 'blocks/Layouts/GlobalLayout';
import { navigationPaths, PAGE_INVALIDATION_INTERVAL } from 'data/constants';
import MylerSection from 'blocks/MylerSection';

interface IMyler extends IGenericPage {}

const Myler: NextPage<IMyler> = ({ globalLayoutProps }) => {
  return (
    <GlobalLayout {...globalLayoutProps}>
      <MylerSection />
      <DownloadApp />
    </GlobalLayout>
  );
};

export default Myler;

export const getStaticProps: GetStaticProps = async () => {
  const genericPageProps = await PageService.getGenericPageProps({
    navPath: navigationPaths.INDEPENDENT_TRAVEL_AGENT,
  });
  return {
    props: {
      ...genericPageProps,
    },
    revalidate: PAGE_INVALIDATION_INTERVAL,
  };
};
